import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {MetadataConfiguration} from "./metadata-configuration";
import {ListItemConfiguration} from "./list-item-configuration";
import {MessageConfiguration} from "./message-configuration";

@JsonObject()
export class LayerListConfiguration {

    /**
     * *Geo.js Property*
     * Groups to add to the layer list
     * --> added to operationalLayers
     */
    @JsonProperty()
    declare groups: ListItemConfiguration[];

    /**
     * *Geo.js Property*
     * Hide items, add actions to items, override settings from webmap (e.g. if item is open)
     * --> goes to operationalLayers
     */
    @JsonProperty()
    declare items: ListItemConfiguration[];

    /**
     * *Geo.js Property*
     * Metadata for layers
     */
    @JsonProperty()
    declare metadata: MetadataConfiguration;

    /**
     * *Geo.js Property*
     * Limit the tree levels. e.g. limitLevel: 1 would list only root level.
     *
     * @default 0 // no limit
     */
    @JsonProperty() limitLevel = 0;
    /**
     * *Geo.js Property*
     * Rebuild the TOC if true.
     *
     * @default false
     */
    @JsonProperty() rebuild = false;
    /**
     * *Geo.js Property*
     * Start the tree at level. e.g. limitLevel: 1 would hide the root level.
     *
     * @default 0 // root Level
     */
    @JsonProperty() startLevel = 0;

    /**
     * *Geo.js Property*
     * Metadata for layers
     */
    @JsonProperty()
    declare preContent?: MessageConfiguration[];
    /**
     * *Geo.js Property*
     * Metadata for layers
     */
    @JsonProperty()
    declare postContent?: MessageConfiguration[];

    /**
     * The widget's default CSS icon class.
     *
     * @deprecated since 4.27. Use {@link module:esri/widgets/LayerList#icon icon} instead.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#iconClass)
     */
    @JsonProperty()
    declare iconClass?: string;
    /**
     * A function that executes each time a [ListItem](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList-ListItem.html) is created.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#listItemCreatedFunction)
     */
    // @JsonProperty()
    // declare listItemCreatedFunction?: ListItemCreatedHandler;
    /**
     * Indicates whether more than one list item may be selected by the user at a single time.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#multipleSelectionEnabled)
     */
    @JsonProperty()
    declare multipleSelectionEnabled?: boolean;
    /**
     * A collection of selected
     * [ListItem](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList-ListItem.html)s
     * representing operational layers selected by the user.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#selectedItems)
     */
    // declare selectedItems?: CollectionProperties<ListItem>;
    /**
     * Indicates whether list items may be selected by the user.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#selectionEnabled)
     */
    @JsonProperty()
    declare selectionEnabled?: boolean;

    /**
     * A reference to the [MapView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-MapView.html) or [SceneView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-SceneView.html).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#view)
     */
    // @JsonProperty()
    // declare view?: (MapViewConfiguration & { type: "2d" }); // | (SceneViewProperties & { type: "3d" });
    /**
     * The view model for this widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#viewModel)
     */
    // @JsonProperty()
    // declare viewModel?: LayerListViewModelProperties;
    /**
     * The visible elements that are displayed within the widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-LayerList.html#visibleElements)
     */
    // declare visibleElements?: LayerListVisibleElements;

    constructor() {}
}
